import { Fields } from "remult";

export class AvailabilityBase {
  /**
   * Day of week
   */
  @Fields.number({
    required: true,
  })
  dow!: 0 | 1 | 2 | 3 | 4 | 5 | 6;

  @Fields.boolean({
    caption: "בוקר",
    defaultValue: () => false,
    dbName: "morning",
  })
  MORNING = false;

  @Fields.boolean({
    caption: "צהריים",
    defaultValue: () => false,
    dbName: "afternoon",
  })
  AFTERNOON = false;

  @Fields.boolean({
    caption: "ערב",
    defaultValue: () => false,
    dbName: "evening",
  })
  EVENING = false;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt? = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt? = new Date();
}
